import { Plus, Trash2 } from 'lucide-react'
import SearchableSelect from './SearchableSelect'

// Construtor visual do formulário parametrizado (oferta.campos_schema).
// value = [{chave,label,tipo,obrigatorio,grupo,opcoes?,fonte?,formatos?}] · onChange(novaLista)
const TIPOS = [
  { value: 'texto', label: 'Texto' }, { value: 'numero', label: 'Número' },
  { value: 'moeda', label: 'Moeda (R$)' }, { value: 'data', label: 'Data' },
  { value: 'selecao', label: 'Seleção' }, { value: 'cpf', label: 'CPF/CNPJ' },
  { value: 'cep', label: 'CEP' }, { value: 'telefone', label: 'Telefone' },
  { value: 'booleano', label: 'Sim/Não' }, { value: 'arquivo', label: 'Arquivo / Upload' },
  { value: 'secao', label: 'Seção (título)' },
]
const slug = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')

export default function CamposBuilder({ value = [], onChange }) {
  const campos = Array.isArray(value) ? value : []
  const upd = (i, patch) => onChange(campos.map((c, idx) => (idx === i ? { ...c, ...patch } : c)))
  const add = () => onChange([...campos, { chave: '', label: '', tipo: 'texto', obrigatorio: false, grupo: '' }])
  const del = (i) => onChange(campos.filter((_, idx) => idx !== i))
  const move = (i, d) => {
    const j = i + d
    if (j < 0 || j >= campos.length) return
    const arr = [...campos];[arr[i], arr[j]] = [arr[j], arr[i]]; onChange(arr)
  }

  return (
    <div className="space-y-2">
      <p className="text-[11px] text-gray-400">Defina os campos que este produto/serviço precisa coletar (inclui uploads). Produtos futuros: só cadastrar aqui — sem programar.</p>
      {campos.length === 0 && <p className="text-xs text-gray-400 italic">Nenhum campo ainda.</p>}
      {campos.map((c, i) => (
        <div key={i} className="border border-gray-200 rounded-xl p-3 space-y-2 bg-gray-50/60">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-[11px] text-gray-500">Rótulo</label>
              <input value={c.label || ''} onChange={(e) => upd(i, { label: e.target.value, chave: c.chave || slug(e.target.value) })}
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" placeholder="Ex.: Conta de energia" />
            </div>
            <div>
              <label className="text-[11px] text-gray-500">Tipo</label>
              <SearchableSelect value={c.tipo} emptyOption={false} onChange={(v) => upd(i, { tipo: v })} options={TIPOS} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-[11px] text-gray-500">Chave (interna)</label>
              <input value={c.chave || ''} onChange={(e) => upd(i, { chave: slug(e.target.value) })}
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm font-mono" placeholder="conta_energia" />
            </div>
            <div>
              <label className="text-[11px] text-gray-500">Grupo / Seção</label>
              <input value={c.grupo || ''} onChange={(e) => upd(i, { grupo: e.target.value })}
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" placeholder="Documentos" />
            </div>
          </div>
          {c.tipo === 'selecao' && (
            <div>
              <label className="text-[11px] text-gray-500">Opções (vírgula) OU fonte (ex.: /distribuidoras)</label>
              <input
                value={Array.isArray(c.opcoes) ? c.opcoes.join(', ') : (c.fonte || '')}
                onChange={(e) => {
                  const t = e.target.value
                  if (t.trim().startsWith('/')) upd(i, { fonte: t.trim(), opcoes: undefined })
                  else upd(i, { opcoes: t.split(',').map((s) => s.trim()).filter(Boolean), fonte: undefined })
                }}
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" placeholder="residencial, comercial  —ou—  /distribuidoras" />
            </div>
          )}
          {c.tipo === 'arquivo' && (
            <div>
              <label className="text-[11px] text-gray-500">Formatos aceitos (vírgula)</label>
              <input value={Array.isArray(c.formatos) ? c.formatos.join(', ') : ''}
                onChange={(e) => upd(i, { formatos: e.target.value.split(',').map((s) => s.trim().replace('.', '')).filter(Boolean) })}
                className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" placeholder="pdf, jpg, png" />
            </div>
          )}
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-1.5 text-xs text-gray-600">
              <input type="checkbox" checked={!!c.obrigatorio} onChange={(e) => upd(i, { obrigatorio: e.target.checked })} className="accent-accent-500" /> Obrigatório
            </label>
            <div className="flex items-center gap-1">
              <button type="button" onClick={() => move(i, -1)} className="text-gray-400 hover:text-gray-700 px-1 text-xs">↑</button>
              <button type="button" onClick={() => move(i, 1)} className="text-gray-400 hover:text-gray-700 px-1 text-xs">↓</button>
              <button type="button" onClick={() => del(i)} className="text-gray-400 hover:text-red-600 p-1"><Trash2 size={15} /></button>
            </div>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="flex items-center gap-1.5 text-sm text-accent-600 font-semibold hover:text-accent-700">
        <Plus size={15} /> Adicionar campo
      </button>
    </div>
  )
}
